import React, { useContext, useEffect, useState } from 'react';
import './QuestionsV2.scss';
import { layoutContext } from '../../DORAAssessment';
import {
  CheckmarkOutline24,
  MisuseOutline24,
  Pending24,
} from '@carbon/icons-react';
import { Scenario } from '../../../data/constants';

interface singleOptionProps {
  options: any[];
}

const SingleOptionV2 = (sOMProps: singleOptionProps) => {
  const { options } = sOMProps;
  const {
    selectedOption,
    setSelectedOption,
    setCurrentScenario,
    selectedItems,
    setSelectedItems,
    questionId,
    setQuestionId,
    goToPrevious,
    setGoToPrevious,
  } = useContext(layoutContext);

  const [selectedRadio, setSelectedRadio] = useState(-1);

  const handleNext = (qId: string) => {
    if (qId === 'results') {
      return (
        setCurrentScenario(Scenario.results),
        setGoToPrevious(false),
        setSelectedItems({
          ...selectedItems,
          [questionId]: selectedOption.optionId,
        })
      );
    } else {
      return (
        setQuestionId(qId),
        setSelectedItems({
          ...selectedItems,
          [questionId]: selectedOption.optionId,
        })
      );
    }
  };

  const handleOptionChange = (item: any, index: number) => {
    setGoToPrevious(false);
    setSelectedRadio(index);
    setSelectedOption(item);
  };

  useEffect(() => {
    if (selectedOption.nextStep != '' && !goToPrevious) {
      handleNext(selectedOption.nextStep);
    }
  }, [selectedOption]);

  const renderIcon = (i: number) => {
    switch (i) {
      case 0:
        return (
          <CheckmarkOutline24 className="dora-assessment-v2__single-option-icon" />
        );
      case 1:
        return (
          <MisuseOutline24 className="dora-assessment-v2__single-option-icon" />
        );
      case 2:
        return <Pending24 className="dora-assessment-v2__single-option-icon" />;
    }
  };

  return (
    <div className="dora-assessment-v2__single-option-container">
      {options.map((option: any, i: number) => (
        <div
          key={option.id}
          className={`bx--col dora-assessment-v2__single-option ${
            selectedRadio === i
              ? 'dora-assessment-v2__single-option-selected'
              : ''
          }`}
          onClick={() => handleOptionChange(option, i)}
        >
          <div
            className={`${
              selectedRadio === i
                ? 'dora-assessment-v2__single-option-card_selected'
                : 'dora-assessment-v2__single-option-card'
            }`}
          >
            {renderIcon(i)}
            <input
              type="radio"
              name="options"
              checked={selectedRadio === i}
              onChange={() => handleOptionChange(option, i)}
              className="dora-assessment-v2__single-option-input"
            />
            <div className="dora-assessment-v2__single-option-text">
              {option.text}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SingleOptionV2;
